var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 1.71106C6.31833 1.71106 1.71387 6.31552 1.71387 11.9968V21.6396C1.71387 21.9959 2.00047 22.2825 2.35672 22.2825H7.2853C8.23083 22.2825 8.99958 21.5137 8.99958 20.5682V14.9968C8.99958 14.0512 8.23083 13.2825 7.2853 13.2825H3.64244V11.9968C3.64244 7.3816 7.3844 3.63963 11.9996 3.63963C16.6148 3.63963 20.3567 7.3816 20.3567 11.9968V13.2825H16.7139C15.7683 13.2825 14.9996 14.0512 14.9996 14.9968V20.5682C14.9996 21.5137 15.7683 22.2825 16.7139 22.2825H21.6424C21.9987 22.2825 22.2853 21.9959 22.2853 21.6396V11.9968C22.2853 6.31552 17.6808 1.71106 11.9996 1.71106ZM7.07101 15.2111V20.3539H3.64244V15.2111H7.07101ZM20.3567 20.3539H16.9282V15.2111H20.3567V20.3539Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerService);
export default __webpack_public_path__ + "static/media/customerService.456fa91e2abcc6b48f15ceae6e62c68b.svg";
export { ForwardRef as ReactComponent };